import { useCallback, useEffect, useRef } from 'react';

export default function useDebounce<T>(time: number = 800) {
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  type TimerFn = () => T | Promise<T>;

  function debounceCallback(fn: TimerFn) {
    async function handleCallback() {
      await fn();
    }
    const timer = setTimeout(handleCallback, time);
    cancelCallback();
    timerRef.current = timer;
  }
  function cancelCallback() {
    const currentTimer = timerRef.current;
    if (currentTimer) {
      clearTimeout(currentTimer);
    }
  }

  const debounce = useCallback(debounceCallback, [time]);
  const cancel = useCallback(cancelCallback, []);

  useEffect(() => cancel, [cancel]);

  return { debounce, cancel };
}
